<div class="container" role="main">
    <form class="memberForm" (ngSubmit)="memberDetailsSubmit()">
        <div class="row main-home">
            <div class="col-md-12">
                <button type="button" class="greyBtn" (click)="back()"
                    style="font-weight : bold;">Go To Previous Section</button>&nbsp;&nbsp;
                <button type="button" class="greyBtn" *ngIf="isInstruction" (click)="openInstruction()"
                    style="font-weight : bold;">Instructions</button>&nbsp;&nbsp;
                <button type="button" class="orangeBtn ml-5" *ngIf="isFormsValid" (click)="memberDetailsSubmit()" [disabled]="!memberFormPart1.valid || !memberFormPart2.valid || !memberFormPart3.valid" [ngStyle]="{'background-color': primaryColor}">Proceed
                        to Next Section</button>
            </div>
        </div>
        <div class="row main-home py-0">
            <div class="col-md-9">
                <p role="heading" aria-level="1">Please enter information regarding the {{title}}</p>
            </div>
        </div>
        <div class="row main-home" role="form">
            <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4" align="center">
                <app-json-form *ngIf="isformloaded" [controlsData]="memberFormData1.controls" [formData]="memberFormPart1"
                    (valueChangeEvent)="valueChange($event)" (InitializationCompletedEvent)="childInitComplete()"></app-json-form>
            </div>
            <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4" align="center">
                <app-json-form *ngIf="isformloaded" [controlsData]="memberFormData2.controls" [formData]="memberFormPart2"
                    (valueChangeEvent)="valueChange($event)" (InitializationCompletedEvent)="childInitComplete()"></app-json-form>
            </div>
            <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4" align="center">
                <app-json-form *ngIf="isformloaded" [controlsData]="memberFormData3.controls" [formData]="memberFormPart3"
                    (valueChangeEvent)="valueChange($event)" (InitializationCompletedEvent)="childInitComplete()"></app-json-form>
            </div>
        </div>
        <div class="row main-home">
            <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3">
                <button type="button" class="orangeBtn" style="float: left;" *ngIf="isFormsValid" (click)="memberDetailsSubmit()" [ngStyle]="{'background-color': primaryColor}">Proceed
                to Next Section</button>
            </div>
        </div>
    </form>
</div>